import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Politician } from '../shared/models/politician.model';
import { Media } from '../shared/models/media.model';
import { Party } from '../shared/models/party.model';
import { Commission } from '../shared/models/commission.model';
import { CountAndResults, PoliticianSearch } from '../shared/types';

@Injectable()
export class PoliticianService {
  private http = inject(HttpClient);


  add(politician: Politician): Observable<void> {
    return this.http.post<void>('/api/politician', politician);
  }

  search(body: PoliticianSearch): Observable<CountAndResults> {
    return this.http.post<CountAndResults>('/api/politicians/search', body);
  }

  get(id: string): Observable<Politician> {
    return this.http.get<Politician>(`/api/politician/${id}`);
  }

  update(politician: Politician): Observable<void> {
    return this.http.put<void>(`/api/politician/${politician._id}`, politician);
  }

  updateSocial(id: string, social: string, username: string): Observable<void> {
    const update = `socials.${social}.username`;
    return this.http.put<void>(`/api/politician/${id}`, { [update]: username });
  }

  delete(politician: Politician): Observable<void> {
    return this.http.delete<void>(`/api/politician/${politician._id}`);
  }

  getParties(): Observable<Party[]> {
    return this.http.get<Party[]>('/api/parties');
  }

  addMedia(media: Media): Observable<void> {
    return this.http.post<void>('/api/media', media);
  }

  getMedias(): Observable<Media[]> {
    return this.http.get<Media[]>('/api/medias');
  }

  getCommissions(): Observable<Commission[]> {
    return this.http.get<Commission[]>('/api/commissions');
  }

}
